/* ============================================================
   CULTURE SUPPLY — cs-cart.js  (v3 — refresh verificado)
   Motor partilhado do drawer + página /cart.
   - Drawer é um <dialog> modal nativo: top layer, acima do header,
     foco e Esc geridos pelo browser, resto da página fica inert.
   - Delegação em fase de CAPTURA: imune a stopPropagation de
     componentes do tema ou do editor.
   - Mutações via Cart AJAX API com Section Rendering.
   - v3: o refresh valida o DOM contra /cart.js; se o Section
     Rendering devolver null/stale (secções em section groups),
     faz fallback a buscar a página /cart completa e extrair o
     HTML do drawer de lá. Corrige o bug do "primeiro add" em que
     o drawer abria vazio até ao refresh manual.
   - Sincroniza o bubble nativo (evento cart:update).
   ============================================================ */
(function () {
  'use strict';
  if (window.__csCartInit) return;
  window.__csCartInit = true;

  var SRC = 'cs-cart';
  var TKEY = 'cs-cart-deadline';

  /* ---------- rotas ---------- */
  function routes() { return (window.Theme && window.Theme.routes) || {}; }
  function addUrl() { return routes().cart_add_url || '/cart/add.js'; }
  function changeUrl() { return routes().cart_change_url || '/cart/change.js'; }
  function updateUrl() { return routes().cart_update_url || '/cart/update.js'; }
  function cartUrl() {
    var r = drawerRoot();
    return (r && r.getAttribute('data-cart-url')) || routes().cart_url || '/cart';
  }

  /* ---------- selectores ---------- */
  function drawerRoot() { return document.querySelector('.cs-cart-drawer[data-cs-cart-root]'); }
  function drawerDialog() { var r = drawerRoot(); return r ? r.querySelector('[data-cs-dialog]') : null; }
  function pageRoot() { return document.querySelector('[data-cs-cart-page]'); }
  function sectionIds() {
    var els = document.querySelectorAll('[data-cs-cart-section][data-section-id]');
    var ids = [];
    Array.prototype.forEach.call(els, function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  /* ---------- fetch ----------
     csFetch = referência ORIGINAL do fetch, capturada antes do nosso
     monkey-patch. As nossas próprias chamadas usam-na para não voltarem
     a passar pelo interceptor (evita sincronizações em duplicado). */
  var csFetch = (typeof window.fetch === 'function') ? window.fetch.bind(window) : null;
  function rawFetch() {
    if (csFetch) return csFetch.apply(null, arguments);
    return fetch.apply(window, arguments);
  }
  function postJSON(url, body) {
    return rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getJSON(url) {
    return rawFetch(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function getHTML(url) {
    return rawFetch(url, { headers: { 'Accept': 'text/html' }, cache: 'no-store' }).then(function (r) { return r.text(); });
  }

  /* ---------- estado ---------- */
  function setBusy(state) {
    var inners = document.querySelectorAll('[data-cs-cart-inner]');
    Array.prototype.forEach.call(inners, function (inner) { inner.classList.toggle('is-busy', !!state); });
  }

  /* ---------- swap de secções ---------- */
  function applyHtml(id, html) {
    if (typeof html !== 'string' || !html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cs-cart-inner]');
    var current = document.querySelector('[data-section-id="' + id + '"] [data-cs-cart-inner]');
    if (fresh && current) { current.innerHTML = fresh.innerHTML; return true; }
    return false;
  }
  function swapFrom(sectionsMap) {
    if (!sectionsMap) { return refreshSections(); }
    var allOk = true;
    sectionIds().forEach(function (id) {
      if (!applyHtml(id, sectionsMap[id])) allOk = false;
    });
    initTimers();
    /* se o Section Rendering falhou nalguma secção (null para secções
       em section groups), garantir consistência via refresh completo */
    if (!allOk) return refreshSections();
    return verifyAndRepair();
  }

  /* Fallback: buscar a página /cart inteira (o header group — e o nosso
     drawer — são renderizados server-side com o carrinho actual) e
     extrair o inner de lá. Funciona independentemente do suporte do
     Section Rendering API à secção. */
  function refreshFromFullPage() {
    return getHTML(cartUrl() + '?_cs=' + Date.now())
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        sectionIds().forEach(function (id) {
          var fresh = doc.querySelector('[data-section-id="' + id + '"] [data-cs-cart-inner]');
          var current = document.querySelector('[data-section-id="' + id + '"] [data-cs-cart-inner]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
        initTimers();
      })
      .catch(function () {});
  }

  /* Verificar se o DOM do drawer bate certo com o estado real do
     carrinho; se não bater (swap falhou/stale), reparar com a página
     completa. Resolve sempre. */
  function verifyAndRepair() {
    return getJSON('/cart.js')
      .then(function (cart) {
        var domHasItems = !!document.querySelector('[data-cs-item]');
        var cartHasItems = cart && cart.item_count > 0;
        if (domHasItems === cartHasItems) return;
        return refreshFromFullPage();
      })
      .catch(function () {});
  }

  function refreshSections() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    // Fonte do Section Rendering: quando NÃO estamos na página /cart (ex. no
    // drawer a partir de uma página de produto), pedimos a partir da rota /cart,
    // que é sempre dinâmica. A página de produto pode servir Section Rendering
    // em "stale-while-revalidate", devolvendo o carrinho "um passo atrás".
    // O timestamp continua como cache-busting adicional do lado do browser.
    var base = pageRoot() ? location.pathname : cartUrl();
    return getJSON(base + '?sections=' + ids.join(',') + '&_cs=' + Date.now())
      .then(function (data) {
        var allOk = true;
        ids.forEach(function (id) {
          if (!applyHtml(id, data && data[id])) allOk = false;
        });
        initTimers();
        if (!allOk) return refreshFromFullPage();
        return verifyAndRepair();
      })
      .catch(function () { return refreshFromFullPage(); });
  }

  /* ---------- bubble nativo ---------- */
  function syncBubble(cart) {
    if (!cart) return;
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: SRC, data: { itemCount: cart.item_count, source: SRC } }
    }));
  }

  /* ---------- abrir / fechar (dialog em top layer) ---------- */
  var closeTimer = null;
  function bindDialog(dlg) {
    if (dlg.__csBound) return;
    dlg.__csBound = true;
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeDrawer(); });
    dlg.addEventListener('close', function () {
      var r = drawerRoot();
      if (r) r.classList.remove('is-open');
      document.documentElement.classList.remove('cs-cart-lock');
    });
  }
  function openDrawer() {
    var root = drawerRoot();
    var dlg = drawerDialog();
    if (!root || !dlg || pageRoot()) return;
    clearTimeout(closeTimer);
    bindDialog(dlg);
    if (!dlg.open) {
      if (typeof dlg.showModal === 'function') {
        try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
      } else {
        dlg.setAttribute('open', '');
      }
    }
    document.documentElement.classList.add('cs-cart-lock');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
  }
  function closeDrawer() {
    var root = drawerRoot();
    var dlg = drawerDialog();
    if (!root || !dlg) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('cs-cart-lock');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      if (dlg.open) { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } }
    }, 340);
  }

  /* ---------- neutralizar drawer nativo ---------- */
  function neutralizeNative() {
    var comps = document.querySelectorAll('cart-drawer-component[auto-open]');
    Array.prototype.forEach.call(comps, function (el) { el.removeAttribute('auto-open'); });
    /* se algum modal nativo invisível estiver aberto, fechá-lo —
       um dialog aberto torna o resto da página inert */
    var stray = document.querySelectorAll('cart-drawer-component dialog[open]');
    Array.prototype.forEach.call(stray, function (d) {
      try { d.close(); } catch (e) { d.removeAttribute('open'); }
    });
  }

  /* ---------- interceptar gatilhos (captura) ---------- */
  function normPath(p) { return (p || '').replace(/\/+$/, '') || '/'; }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var hit = e.target.closest(
      '[data-testid="cart-drawer-trigger"], [data-cart-toggle], .js-drawer-open-cart, [aria-controls="cart-notification"]'
    );
    if (!hit) {
      var anchor = e.target.closest('a[href]');
      if (anchor) {
        try {
          var u = new URL(anchor.href, location.origin);
          if (u.origin === location.origin && normPath(u.pathname) === normPath(cartUrl())) hit = anchor;
        } catch (err) {}
      }
    }
    if (!hit) return;
    if (hit.hasAttribute('data-cs-allow')) return;      // navegação permitida
    if (hit.closest('[data-cs-cart-section]')) return;  // dentro da nossa UI
    if (pageRoot()) return;                              // já estamos na /cart
    if (!drawerRoot()) return;
    e.preventDefault();
    e.stopPropagation();
    openDrawer();
  }, true);

  /* ---------- sincronização com o carrinho (debounced) ----------
     Chamado quando algo mexe no carrinho fora da nossa UI (add nativo do
     Horizon, botões custom, apps). Coalesce múltiplos gatilhos (evento +
     fetch) num único refresh; abre o drawer se o gatilho foi um "add". */
  var syncTimer = null;
  var syncShouldOpen = false;
  function scheduleSync(shouldOpen) {
    if (shouldOpen) syncShouldOpen = true;
    neutralizeNative();
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var doOpen = syncShouldOpen;
      syncShouldOpen = false;
      refreshSections().then(function () {
        var root = drawerRoot();
        if (doOpen && root && root.getAttribute('data-auto-open') === 'true' && !pageRoot()) openDrawer();
      });
    }, 120);
  }

  /* Interceptar as chamadas de rede ao carrinho — mecanismo principal.
     É agnóstico ao tema: apanha qualquer add/change/update ao /cart,
     seja do botão nativo do Horizon, dos botões custom ou de apps.
     As NOSSAS chamadas usam csFetch (não passam por aqui). */
  if (csFetch) {
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = '';
      try { url = (input && typeof input === 'object' && input.url) ? input.url : String(input || ''); } catch (e) {}
      var promise = csFetch.apply(null, args);
      if (url && /\/cart\/(add|change|update|clear)(\.js|\b)/i.test(url)) {
        var isAdd = /\/cart\/add/i.test(url);
        promise.then(function (res) {
          // não consumimos o body (res.ok não lê o stream) — o tema continua a poder lê-lo
          if (res && res.ok) scheduleSync(isAdd);
        }).catch(function () {});
      }
      return promise;
    };
  }

  /* Backup por eventos: alguns fluxos disparam eventos em vez de (ou além
     de) fetch. Ignoramos os nossos próprios (source cs-cart). */
  document.addEventListener('cart:update', function (e) {
    var src = e.detail && e.detail.data && e.detail.data.source;
    if (src && String(src).indexOf('cs-cart') === 0) return;
    scheduleSync(true);
  });
  document.addEventListener('cart:refresh', function () { scheduleSync(true); }); // add custom (cs-pd, quick-add, upsells) → abre o drawer com slide

  /* ---------- mutações ---------- */
  function changeQty(key, qty) {
    if (!key) return;
    setBusy(true);
    postJSON(changeUrl(), { id: key, quantity: qty, sections: sectionIds() })
      .then(function (cart) { syncBubble(cart); return swapFrom(cart.sections); })
      .catch(function () { return refreshSections(); })
      .then(function () { setBusy(false); });
  }
  function addVariant(variantId, qty) {
    if (!variantId) return;
    setBusy(true);
    postJSON(addUrl(), { id: variantId, quantity: qty || 1, sections: sectionIds() })
      .then(function (res) {
        return Promise.resolve(swapFrom(res.sections)).then(function () { return getJSON('/cart.js'); });
      })
      .then(function (cart) { syncBubble(cart); ensureTimer(cart); })
      .catch(function () { return refreshSections(); })
      .then(function () { setBusy(false); });
  }

  /* ---------- desconto (espelha o nativo) ---------- */
  function currentCodes(sectionEl) {
    return Array.prototype.slice.call(sectionEl.querySelectorAll('[data-cs-discount-pill][data-code]'))
      .map(function (p) { return p.getAttribute('data-code'); }).filter(Boolean);
  }
  function applyDiscount(sectionEl, code) {
    if (!sectionEl || !code) return;
    var existing = currentCodes(sectionEl);
    if (existing.indexOf(code) !== -1) { clearInput(sectionEl); return; }
    setBusy(true);
    postJSON(updateUrl(), { discount: existing.concat([code]).join(','), sections: sectionIds() })
      .then(function (data) {
        var codes = data.discount_codes || [];
        var match = codes.filter(function (d) { return d.code === code; })[0];
        if (match && match.applicable === false) {
          showMsg(sectionEl, 'Esse código não é válido ou não se aplica ao teu carrinho.');
        }
        clearInput(sectionEl);
        return swapFrom(data.sections);
      })
      .catch(function () { showMsg(sectionEl, 'Não foi possível aplicar o código. Tenta de novo.'); })
      .then(function () { setBusy(false); });
  }
  function removeDiscount(sectionEl, code) {
    if (!sectionEl || !code) return;
    var existing = currentCodes(sectionEl);
    var idx = existing.indexOf(code);
    if (idx === -1) return;
    existing.splice(idx, 1);
    setBusy(true);
    postJSON(updateUrl(), { discount: existing.join(','), sections: sectionIds() })
      .then(function (data) { return swapFrom(data.sections); })
      .catch(function () { return refreshSections(); })
      .then(function () { setBusy(false); });
  }

  /* ---------- nota ---------- */
  var noteTimer = null;
  function updateNote(val) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { postJSON(updateUrl(), { note: val }).catch(function () {}); }, 600);
  }

  /* ---------- mensagens ---------- */
  function showMsg(sectionEl, text) {
    var el = sectionEl.querySelector('[data-cs-cart-msg]');
    if (!el) return;
    el.textContent = text;
    el.classList.add('is-visible');
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.classList.remove('is-visible'); }, 4000);
  }
  function clearInput(sectionEl) {
    var input = sectionEl.querySelector('[data-cs-discount-form] input[name="discount"]');
    if (input) input.value = '';
  }

  /* ---------- delegação de acções (CAPTURA — imune a stopPropagation) ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var el;
    var dlg = drawerDialog();
    if (dlg && e.target === dlg) { closeDrawer(); return; } // clique no ::backdrop
    if (e.target.closest('[data-cs-close]')) {
      e.preventDefault(); e.stopPropagation();
      closeDrawer();
      return;
    }
    if ((el = e.target.closest('[data-cs-qty]'))) {
      e.preventDefault(); e.stopPropagation();
      var w = el.closest('[data-cs-item]'); if (!w) return;
      var cur = parseInt(w.getAttribute('data-qty'), 10) || 0;
      var next = el.getAttribute('data-cs-qty') === 'up' ? cur + 1 : cur - 1;
      if (next < 0) next = 0;
      changeQty(w.getAttribute('data-key'), next);
      return;
    }
    if ((el = e.target.closest('[data-cs-remove]'))) {
      e.preventDefault(); e.stopPropagation();
      var wr = el.closest('[data-cs-item]'); if (!wr) return;
      changeQty(wr.getAttribute('data-key'), 0);
      return;
    }
    if ((el = e.target.closest('[data-cs-upsell-toggle]'))) {
      e.preventDefault(); e.stopPropagation();
      var card = el.closest('[data-cs-upsell-card]');
      if (card) card.classList.add('show-variants');
      return;
    }
    if ((el = e.target.closest('[data-cs-upsell-add]'))) {
      e.preventDefault(); e.stopPropagation();
      var vid = el.getAttribute('data-variant');
      if (vid) { el.classList.add('is-adding'); addVariant(vid, 1); }
      return;
    }
    if ((el = e.target.closest('[data-cs-discount-remove]'))) {
      e.preventDefault(); e.stopPropagation();
      var sec = el.closest('[data-cs-cart-section]');
      removeDiscount(sec, el.getAttribute('data-code'));
      return;
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-cs-discount-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var sec = form.closest('[data-cs-cart-section]');
    var input = form.querySelector('input[name="discount"]');
    applyDiscount(sec, input ? input.value.trim() : '');
  }, true);

  document.addEventListener('input', function (e) {
    var ta = e.target && e.target.closest && e.target.closest('[data-cs-note]');
    if (ta) updateNote(ta.value);
  }, true);

  /* Esc extra para o fallback não-modal (o modal já trata via 'cancel') */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    var root = drawerRoot();
    if (root && root.classList.contains('is-open')) closeDrawer();
  });

  /* ---------- timer de reserva ---------- */
  function ensureTimer(cart) {
    var hasItems = cart ? cart.item_count > 0 : !!document.querySelector('[data-cs-item]');
    if (!hasItems) { sessionStorage.removeItem(TKEY); return; }
    if (!sessionStorage.getItem(TKEY)) {
      var el = document.querySelector('[data-cs-timer]');
      var mins = el ? parseInt(el.getAttribute('data-minutes'), 10) : 20;
      if (!mins || mins < 1) mins = 20;
      sessionStorage.setItem(TKEY, String(Date.now() + mins * 60000));
    }
  }
  var tickInt = null;
  function initTimers() {
    if (document.querySelector('[data-cs-item]')) ensureTimer();
    else sessionStorage.removeItem(TKEY);
    tick();
    if (!tickInt) tickInt = setInterval(tick, 1000);
  }
  function tick() {
    var timers = document.querySelectorAll('[data-cs-timer]');
    if (!timers.length) return;
    var deadline = parseInt(sessionStorage.getItem(TKEY), 10);
    var remain = deadline ? deadline - Date.now() : 0;
    if (!deadline || remain <= 0) {
      if (deadline) sessionStorage.removeItem(TKEY);
      Array.prototype.forEach.call(timers, function (t) { t.classList.add('is-expired'); });
      return;
    }
    var mm = Math.floor(remain / 60000);
    var ss = Math.floor((remain % 60000) / 1000);
    var txt = mm + ':' + (ss < 10 ? '0' + ss : ss);
    Array.prototype.forEach.call(timers, function (t) {
      t.classList.remove('is-expired');
      t.classList.toggle('is-urgent', remain < 300000);
      var c = t.querySelector('[data-cs-timer-count]');
      if (c) c.textContent = txt;
    });
  }

  /* ---------- API pública (usada pelo design mode das secções) ---------- */
  window.CSCart = { open: openDrawer, close: closeDrawer, refresh: refreshSections };

  /* ---------- init ---------- */
  function init() {
    neutralizeNative();
    initTimers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
